import * as React from 'react';

import { Box, Card, CardContent, CardHeader, Typography } from '@mui/material';
import {
  DateField,
  EditButton,
  RecordContextProvider,
  useListContext,
  useTranslate,
} from 'react-admin';

import { ICatalogsPdf } from '../../types';

const MobileGrid = () => {
  const translate = useTranslate();
  const { data, isLoading } = useListContext<ICatalogsPdf>();

  if (isLoading || data.length === 0) {
    return null;
  }

  return (
    <Box margin="0.5em">
      {data.map((record) => (
        <RecordContextProvider key={record.id} value={record}>
          <Card sx={{ margin: '0.5rem 0' }}>
            <CardHeader title={`${record.name}`} action={<EditButton />} />
            <CardContent sx={{ pt: 0 }}>
              <Typography variant="body2">
                {translate('resources.catalogs_pdf.fields.date')}
                :&nbsp;
                <DateField source="date" />
              </Typography>
            </CardContent>
          </Card>
        </RecordContextProvider>
      ))}
    </Box>
  );
};

export default MobileGrid;
